import I18NextVue from 'i18next-vue'

export const initI18nService = async () => {
  await $core.$i18n.initialize({
    selectableLangs: [
      { value: 'ja', label: '日本語', langKeys: ['ja', 'ja-JP'] },
      { value: 'en', label: 'English', langKeys: ['en', 'en-US', 'en-GB'] },
    ],
    fallbackLng: 'ja',
  })
  $core.VueClass.use(I18NextVue, { i18next: $core.$i18n.i18nInstance })
}
